import { EventEmitter } from '@angular/core';
import { ContactsButtonModel } from '../../../Shared/components/Contacts/contacts-button.model';
import { ContactsButtonTypesEnum } from '../../../Shared/components/Contacts/contact-button-types.enum';

export const storyContactsButton: ContactsButtonModel[] = [
    {
        buttonClick: new EventEmitter(),
        onButtonClickAction: function (item) {
        },
        iconClasses: 'fa-regular fa-duotone fa-trash-can',
        disabled: false,
        type: ContactsButtonTypesEnum.Delete
    },
    {
        buttonClick: new EventEmitter(),
        onButtonClickAction: function (item) {
        },
        iconClasses: 'fa-regular fa-duotone fa-pen',
        disabled: false,
        type: ContactsButtonTypesEnum.Edit
    },
    {
        buttonClick: new EventEmitter(),
        iconClasses: 'fa-regular fa-duotone fa-plus',
        disabled: false,
        type: ContactsButtonTypesEnum.Add
    },
];
